import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", compact = false }) => (
  <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="brand-logo">
    <img src="/logo-mark.png?v=2" alt="Salesman Connect" className="w-9 h-9 object-contain group-hover:scale-105 transition-transform duration-300 shrink-0" />
    <span className={`text-lg font-extrabold tracking-tighter text-white whitespace-nowrap ${compact ? "hidden sm:inline" : ""}`}>
      Salesman<span className="text-emerald-400">Connect</span><sup className="text-[0.6em] font-semibold text-slate-400 ml-0.5 align-super">™</sup>
    </span>
  </Link>
);
